import React from 'react';
import classnames from 'classnames';
import EmptyBackground from '../EmptyBackground';
import { useDeviationViewContext } from '../../../Context';
import s from './Literature.scss';
export const LiteratureStageBackground = ()=>{
    const { isFullscreen } = useDeviationViewContext();
    return /*#__PURE__*/ React.createElement(EmptyBackground, {
        className: classnames(!isFullscreen && s['background'])
    });
};
LiteratureStageBackground.displayName = 'LiteratureStageBackground';
export default LiteratureStageBackground;

//# sourceMappingURL=Literature.js.map